import React from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import styles from './Layout.module.css';

/**
 * Layout Component
 * Wraps pages with navbar and footer
 */
const Layout = ({ children }) => {
  return (
    <div className={styles.layout}>
      <Navbar />
      <div className={styles.contentShell}>
        <Sidebar />
        <main className={styles.mainContent}>
          <div className={styles.container}>
            {children}
          </div>
        </main>
      </div>
      <footer className={styles.footer}>
        <p>&copy; {new Date().getFullYear()} Digital Health Agency (DHA) Kenya. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Layout;
